import { setLocale } from 'yup'

setLocale({
    mixed: {
        // eslint-disable-next-line
        required: '${path} is Missing',
    },
})
